"use strict";
// Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var SignalingClientConnectionRequest_1 = require("../signalingclient/SignalingClientConnectionRequest");
var SignalingClientEventType_1 = require("../signalingclient/SignalingClientEventType");
var BaseTask_1 = require("./BaseTask");
var OpenSignalingConnectionTask = /** @class */ (function (_super) {
    __extends(OpenSignalingConnectionTask, _super);
    function OpenSignalingConnectionTask(context) {
        var _this = _super.call(this, context.logger) || this;
        _this.context = context;
        _this.taskName = 'OpenSignalingConnectionTask';
        _this.taskCanceler = null;
        return _this;
    }
    OpenSignalingConnectionTask.prototype.cancel = function () {
        if (this.taskCanceler) {
            this.taskCanceler.cancel();
            this.taskCanceler = null;
        }
    };
    OpenSignalingConnectionTask.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            var configuration, startTimeMs, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        configuration = this.context.meetingSessionConfiguration;
                        this.context.signalingClient.openConnection(new SignalingClientConnectionRequest_1.default(configuration.urls.signalingURL, configuration.credentials.joinToken));
                        startTimeMs = Date.now();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                var WebSocketOpenInterceptor = /** @class */ (function () {
                                    function WebSocketOpenInterceptor(signalingClient) {
                                        this.signalingClient = signalingClient;
                                    }
                                    WebSocketOpenInterceptor.prototype.cancel = function () {
                                        this.signalingClient.removeObserver(this);
                                        reject(new Error("OpenSignalingConnectionTask got canceled while waiting to open signaling connection"));
                                    };
                                    WebSocketOpenInterceptor.prototype.handleSignalingClientEvent = function (event) {
                                        switch (event.type) {
                                            case SignalingClientEventType_1.default.WebSocketOpen:
                                                this.signalingClient.removeObserver(this);
                                                resolve();
                                                break;
                                            case SignalingClientEventType_1.default.WebSocketFailed:
                                                this.signalingClient.removeObserver(this);
                                                reject(new Error('WebSocket connection failed'));
                                                break;
                                        }
                                    };
                                    return WebSocketOpenInterceptor;
                                }());
                                var interceptor = new WebSocketOpenInterceptor(_this.context.signalingClient);
                                _this.context.signalingClient.registerObserver(interceptor);
                                _this.taskCanceler = interceptor;
                            })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        throw error_1;
                    case 4:
                        this.context.signalingOpenDurationMs = Math.round(Date.now() - startTimeMs);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    return OpenSignalingConnectionTask;
}(BaseTask_1.default));
exports.default = OpenSignalingConnectionTask;
//# sourceMappingURL=OpenSignalingConnectionTask.js.map